module.exports = __webpack_public_path__ + "img/logo-print.e6ce2fa0.png";